module.exports = __webpack_public_path__ + "img/gn.svg";